module.exports = __webpack_public_path__ + "media/21.0fa788b1.mp3";